<template>
  <div class="site-contents my-account-payment d-flex align-items-top flex-wrap">
    <div class="container-fluid custom-container">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-12"></div>
        <div class="col-lg-6 col-md-4 col-sm-12">
          <div class="account-payment-detail account-form">
            <!-- <div class="gr-form"> -->
            <!-- <div class="account-details"> -->
            <h3>Reset Password</h3>
            <form @submit="changePassword" id="changePassword">
              <div
                class="alert alert-primary alert-dismissible"
                role="alert"
                v-if="showSuccessAlertMessage"
              >
                {{apiSuccessMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showSuccessAlertMessage = !showSuccessAlertMessage"
                />
                <!-- <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
                </button>-->
              </div>
              <div
                class="alert alert-danger alert-dismissible"
                role="alert"
                v-if="showAlertMessage"
              >
                {{apiErrorMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showAlertMessage=!showAlertMessage"
                />
                <!-- <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                @click="showAlertMessage=!showAlertMessage"
              >
                <span aria-hidden="true">&times;</span>
                </button>-->
              </div>
              <div class="form-group">
                <label for="current-password" class="current-password">Current Password</label>
                <input
                  :type="currentPasswordFieldType"
                  class="form-control"
                  id="currentPassword"
                  v-model="currentPassword"
                  name="currentPassword"
                  data-vv-as="current password"
                  v-validate="'required'"
                />
                <span
                  toggle="#currentPassword"
                  :class="currentPasswordShowIcon"
                  @click="switchCurrentPasswordVisibility"
                ></span>
                <span class="invalid-feedback">{{ errors.first('currentPassword') }}</span>
              </div>
              <div class="form-group">
                <label for="new-password" class="new-password">New Password</label>
                <input
                  :type="newPasswordFieldType"
                  class="form-control"
                  id="newPassword"
                  v-model="newPassword"
                  name="newPassword"
                  ref="newPassword"
                  data-vv-as="new password"
                  data-vv-validate-on="blur"
                  v-validate="'required|passwordFormat'"
                />
                <span
                  toggle="#newPassword"
                  :class="newPasswordShowIcon"
                  @click="switchNewPasswordVisibility"
                ></span>
                <span class="invalid-feedback">{{ errors.first('newPassword') }}</span>
              </div>
              <div class="form-group">
                <label for="new-password-repeat" class="new-password-repeat">Repeat New Password</label>
                <input
                  :type="repeatPasswordFieldType"
                  class="form-control"
                  id="newPasswordRepeat"
                  v-model="newPasswordRepeat"
                  name="newPasswordRepeat"
                  data-vv-as="repeat new password"
                  data-vv-validate-on="blur"
                  v-validate="'required|confirmed:newPassword'"
                />
                <span
                  toggle="#newPasswordRepeat"
                  :class="repeatPasswordShowIcon"
                  @click="switchRepeatPasswordVisibility"
                ></span>
                <span class="invalid-feedback">{{ errors.first('newPasswordRepeat') }}</span>
              </div>
              <button type="submit" class="btn btn-primary">Change Password</button>
              <router-link to="/accountDetails" class="btn btn-secondary btn-cancel">Cancel</router-link>
            </form>
          </div>
          <!-- </div> -->
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { CHANGE_PASSWORD } from "../../store/user/action.type";
export default {
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      newPasswordRepeat: "",
      apiSuccessMessage: "",
      apiErrorMessage: "",
      showAlertMessage: false,
      showSuccessAlertMessage: false,
      currentPasswordFieldType: "password",
      newPasswordFieldType: "password",
      repeatPasswordFieldType: "password",
      currentPasswordShowIcon: "fa fa-fw fa-eye field-icon toggle-password",
      newPasswordShowIcon: "fa fa-fw fa-eye field-icon toggle-password",
      repeatPasswordShowIcon: "fa fa-fw fa-eye field-icon toggle-password"
    };
  },
  created() {
    this.$validator.extend("passwordFormat", {
      getMessage: () =>
        "Password must contain at least one uppercase, lowercase, digit and 8 characters long",
      validate: value =>
        value.match(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])[A-Za-z\d@$!%*#?&]{8,}$/
        ) !== null
    });
  },
  methods: {
    changePassword(e) {
      e.preventDefault();
      this.apiErrorMessage = "";
      this.apiSuccessMessage = "";
      this.showAlertMessage = false;
      this.showSuccessAlertMessage = false;
      const passwordDetails = {
        oldPassword: this.currentPassword,
        newPassword: this.newPassword
      };
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store
            .dispatch(CHANGE_PASSWORD, passwordDetails)
            .then(response => {
              if (response.status != 200) {
                this.showAlertMessage = true;
                this.apiErrorMessage = response.data.message;
              } else {
                this.showSuccessAlertMessage = true;
                this.apiSuccessMessage = response.data.message;
              }
              this.resetForm();
            })
            .catch(error => {
              this.showAlertMessage = true;
              this.apiErrorMessage = error.response.data.message;
            });
        }
      });
    },
    resetForm() {
      this.currentPassword = "";
      this.newPassword = "";
      this.newPasswordRepeat = "";
      this.$validator.reset();
    },
    switchCurrentPasswordVisibility() {
      this.currentPasswordFieldType =
        this.currentPasswordFieldType === "password" ? "text" : "password";
      this.currentPasswordShowIcon =
        this.currentPasswordShowIcon ===
        "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    },
    switchNewPasswordVisibility() {
      this.newPasswordFieldType =
        this.newPasswordFieldType === "password" ? "text" : "password";
      this.newPasswordShowIcon =
        this.newPasswordShowIcon ===
        "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    },
    switchRepeatPasswordVisibility() {
      this.repeatPasswordFieldType =
        this.repeatPasswordFieldType === "password" ? "text" : "password";
      this.repeatPasswordShowIcon =
        this.repeatPasswordShowIcon ===
        "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    }
  }
  // watch: {
  //   showAlertMessage(newData) {
  //     if (newData) {
  //       var self = this;
  //       setTimeout(function() {
  //         self.showAlertMessage = false;
  //         // self.showSpinner = false;
  //       }, 2000);
  //     }
  //   },
  //   showSuccessAlertMessage(newData) {
  //     if (newData) {
  //       var self = this;
  //       setTimeout(function() {
  //         self.showSuccessAlertMessage = false;
  //         // self.showSpinner = false;
  //       }, 2000);
  //     }
  //   }
  // }
};
</script>

<style>
.form-group input:focus {
  background: transparent;
}
.btn-cancel {
  margin-left: 20px;
}
/* .gr-form {
  margin-left: 15.875rem;
} */
</style>